export default __webpack_public_path__ + "static/media/Pan.6b40d850.svg";